// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export interface NotificationFooter {
  id: string;
  name: string;
  content: string;
  html_content?: string;
  is_default: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const useNotificationFooters = () => {
  const [footers, setFooters] = useState<NotificationFooter[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchFooters = async () => {
    try {
      setIsLoading(true);
      const { data, error } = await supabase
        .from('notification_footers')
        .select('*')
        .eq('is_active', true)
        .order('is_default', { ascending: false })
        .order('name');

      if (error) {
        console.error('Error fetching footers:', error);
        return;
      }

      setFooters(data || []);
    } catch (error) {
      console.error('Error fetching footers:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFooters();
  }, []);

  const createFooter = async (footerData: Omit<NotificationFooter, 'id' | 'created_at' | 'updated_at'>) => {
    try {
      const { data, error } = await supabase
        .from('notification_footers')
        .insert([footerData])
        .select()
        .single();

      if (error) {
        console.error('Error creating footer:', error);
        return null;
      }

      await fetchFooters();
      return data;
    } catch (error) {
      console.error('Error creating footer:', error);
      return null;
    }
  };

  const updateFooter = async (id: string, updates: Partial<NotificationFooter>) => {
    try {
      const { error } = await supabase
        .from('notification_footers')
        .update(updates)
        .eq('id', id);

      if (error) {
        console.error('Error updating footer:', error);
        return false;
      }

      await fetchFooters();
      return true;
    } catch (error) {
      console.error('Error updating footer:', error);
      return false;
    }
  };

  const deleteFooter = async (id: string) => {
    try {
      const { error } = await supabase
        .from('notification_footers')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Error deleting footer:', error);
        return false;
      }

      await fetchFooters();
      return true;
    } catch (error) {
      console.error('Error deleting footer:', error);
      return false;
    }
  };

  return {
    footers,
    isLoading,
    createFooter,
    updateFooter,
    deleteFooter,
    refetch: fetchFooters
  };
};